import { companySeekerRoleOptions } from "./companySeekerRoleOptions"
import { companyProviderRoleOptions } from "./companyProviderRoleOptions"

export const roleOptions = [
  ...companySeekerRoleOptions,
  ...companyProviderRoleOptions,
]
